import fr from "ra-language-french";

export default {
  ...fr,
  rules: {
    name: "Règle |||| Règles",
    menu: "Règles",
    create: {
      title: "Créer une règle",
    },
    edit: {
      title: "Modifier une règle",
    },
    list: {
      title: "Règles",
    },
    fields: {
      id: "Id",
      name: {
        label: "Nom",
        helper: "Le nom de la règle",
      },
      rate: {
        label: "Taux",
        helper: "Le taux de la règle",
      },
      countriesFrom: {
        label: "Pays d'origine",
        helper: "Les pays d'origine de la règle, séparés par des virgules",
      },
      countriesTo: {
        label: "Pays de destination",
        helper: "Les pays de destination de la règle, séparés par des virgules",
      },
      sellersLabel: {
        label: "Libellé des vendeurs",
        helper: "Le libellé des vendeurs de la règle, séparés par des virgules",
      },
      statesTo: {
        label: "Libéllé des états",
        helper: "Le libellé des états, séparés par des virgules si nécessaire",
      },
      madeInCountries: {
        label: "Libéllé 'Made in'",
        helper: "Le libellé 'made in', séparés par des virgules si nécessaire",
      },
      threshold: {
        label: "Seuil",
        helper: "Le seuil de la règle si nécessaire",
      },
      currencyCode: {
        label: "Devise",
        helper: "La devise de la règle si nécessaire",
      },
      titles: {
        ruleDetails: "Détails de la règle",
        countries: "Pays",
        sellers: "Vendeurs",
        statesTo: "États de destination",
        madeInCountries: "Made In Countries",
        threshold: "Seuil",
        currencyCode: "Devise",
      },
    },
  },
  rulesDeemedSupplier: {
    menu: "Fournisseur présumé",
    create: {
      title: "Créer une règle pour fournisseur présumé",
    },
    edit: {
      title: "Modifier une règle pour fournisseur présumé",
    },
    list: {
      title: "Règles pour fournisseurs présumés",
    },
    fields: {
      generalInfo: "Informations générales",
      countries: "Pays",
      financialInfo: "Informations financières",
      name: {
        label: "Nom de la règle",
        helper: "Entrez le nom de la règle pour le fournisseur présumé.",
      },
      threshold: {
        label: "Seuil",
        helper: "Entrez la valeur du seuil pour cette règle.",
      },
      taxIdentifier24s: {
        label: "Identifiant fiscal 24s",
        helper: "Entrez l'identifiant fiscal 24s.",
      },
      taxIdentifierName: {
        label: "Nom de l'identifiant fiscal",
        helper: "Entrez le nom de l'identifiant fiscal.",
      },
      countriesFrom: {
        label: "Pays d'origine",
        helper: "Liste des pays d'origine, séparés par des virgules.",
      },
      countriesTo: {
        label: "Pays de destination",
        helper: "Liste des pays de destination, séparés par des virgules.",
      },
      exceptCountriesFrom: {
        label: "Pays exclus",
        helper: "Liste des pays à exclure, séparés par des virgules.",
      },
      currency: {
        label: "Devise",
        helper: "Sélectionnez la devise pour cette règle.",
      },
      sapAccount1: {
        label: "Compte SAP 1",
        helper: "Entrez le compte SAP principal.",
      },
      sapAccount2: {
        label: "Compte SAP 2",
        helper: "Entrez le compte SAP secondaire (optionnel).",
      },
    },
  },
};
